<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit"
            :close-on-click-modal="false"
            :before-close="closePopup">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <div :class="{'date': true, 'inl-blk': true, 'img_date': true,'img_date_with_no_img': (!uploadUrl && (!updateResponse || !updateResponse.value))}">
				{{ qDate }}
			</div>
            <div class="inl-blk">
                <div class="response-image">
                    <div class="image-holder-cont inl">
                        <div :class="{'with_img_border ' : (!!uploadUrl || (updateResponse && updateResponse.value)), 'file_upload_error_border' : (attachStatus === 'upload-failed'), 'no_img_border' : (!uploadUrl && (!updateResponse || !updateResponse.value))}">
                            <div class="image-holder" v-if="(!!uploadUrl || (updateResponse && updateResponse.value)) && attachStatus !== 'upload-failed'" :href="uploadUrl ? uploadUrl : updateResponse.value">
                                <a target="_blank" class="image-href">
                                    <img :src="uploadUrl ? uploadUrl : updateResponse.value"/>
                                </a>
                                <el-button class="remove-image" @click="removeResponse()" icon="el-icon-close" circle></el-button>
                            </div>
                            <div class="image-holder" v-else-if="attachStatus === 'upload-failed'">
                                <ErrorIcon></ErrorIcon>
                            </div>
                            <div class="image-holder" v-else>
                                <span class="no-image no-answer">No Image</span>
                            </div>
                        </div>
                        <div class="upld-err-msg" v-show="attachStatus === 'upload-failed'">
                            <span>File upload failed</span>
                        </div>
                    </div>
                    <div class="image-uploader inl">
                        <label for="uploadFileRecord" v-if="imageUploadStatus == 'uploading'">
                            <LoadSpinner type="primary-light"></LoadSpinner>
                        </label>
                        <label for="uploadFileRecord" v-else>
                            {{imageUploadStatus}}
                        </label>
                        <input 
                            id="uploadFileRecord" 
                            type="file" 
                            ref="attachFile" 
                            name="file"
                            @change="doUpload">
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="mandatory-quest" v-if="checkIfMandatory()"> 
                    <span>
                        * Mandatory
                    </span>
                </div>
                <el-button type="text" size="small" class="cancel-button" @click="closePopup()">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="!enableSave"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from '.'
import Icons from '../analysis/response/icon'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'edit-image-upload',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            enableSave: false,
            attachStatus: 'none',
            imageUploadStatus: 'Upload New',
            attachingFile: null,
            uploadUrl: null
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey',
            'uploadFile'
        ]),
        doUpload(uploadFile) {
            if (this.$refs.attachFile && this.$refs.attachFile.files.length > 0) {
                this.attachStatus = 'ongoing'
                this.enableSave = false
                this.imageUploadStatus = 'uploading'
                this.attachingFile = this.$refs.attachFile.files[0]
                this.uploadFile({
                    file: this.attachingFile,
                    patientId: this.patient.id
                })
                .then((uploadUrl) => {
                    this.uploadUrl = uploadUrl
                    this.attachStatus = 'complete'
                    this.imageUploadStatus = 'Upload New'
                    this.enableSave = true
                })
                .catch((error) => {
                    this.attachStatus = 'upload-failed'
                    this.uploadUrl = null
                    this.imageUploadStatus = 'Try again'
                    this.enableSave = false
                })
            } else {
                this.enableSave = this.checkIfMandatory() ? false : true
            }
        },
        closePopup() {
            this.showEdit = false
            this.uploadUrl = null
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.attachStatus = 'none'
            this.attachingFile = null
            this.imageUploadStatus = 'Upload New'
        },
        removeResponse() {
            this.updateResponse = null
            this.uploadUrl = null
            this.attachStatus = 'none'
            this.imageUploadStatus = 'Upload New'
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.showEdit = false
                    this.enableSave = false
                })
        },
        getQuestionResponse() {
            if(!this.oresponse)
                return ''
            else {
                if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0) {
                    return this.oresponse[0]
                } else if(this.oresponse && typeof this.oresponse === 'object') {
                    return {
                        answer: this.oresponse[0].image_description ? this.oresponse[0].image_description : '',
                        value: this.oresponse[0].image_url,
                    }
                } else {
                    return null
                }
            }
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }

            if(!!this.uploadUrl || (this.updateResponse != null && this.updateResponse != '')) {
                let answer = {
                    answer: this.updateResponse && this.updateResponse.answer ? this.updateResponse.answer : '',
                    value: this.uploadUrl ? this.uploadUrl : this.updateResponse.value,
                }
                if(this.questionResponseId())
                    answer.id = this.questionResponseId()
                else
                    answer.id = uuidv4()

                update.answer = [answer]
            }
            
            return update
        },
        questionResponseId() {
            if(this.response && Array.isArray(this.response) && this.response.length > 0)
                return this.response[0].id
            return false
        }
    },

    computed: {
    },

    components: {
        LoadSpinner,
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';

.response-image {
    display: inline-flex;
    flex-direction: row;
    width: 100%;
    height: 100px;
    justify-content: flex-start;
    align-items: center;

    .image-holder-cont {
        height: 90px;
        width: 145px;
        margin: 0 10px;
        // padding: 0 10px;

        .image-holder {
            margin: 0 5px;
            height: 85px;
            width: 130px;
            display: inline-flex;
            justify-content: center;
            align-items: center;

            .image-href {
                width: 86%;
                height: 100%;

                img {
                    width: 130px;
                    height: 87px;
                }   
            }

            .remove-image {
                padding: 0px;
                color: #FFFFFF;
                background-color: #525252;
            }

            span.no-image {
                height: 20px;
                width: 75px;
                font-size: 13px;
            }

            button {
                position: relative;
                top: -43px;
                right: -16px;
            }
        }
    }

    .image-uploader {
        width: 120px;
        height: 30px;
        margin: 0 10px;

        input {
            display: none;
        }

        label {
            height: 25px;
            width: 100px;
            background-color: #2D3E4F;
            color: white;
            border-radius: 20px;

            display: inline-flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 13px 8px;

            svg {
                width: 15px;
                height: 15px;

                ::v-deep circle {
                    stroke: white !important;
                }
            }
        }
    }
}

.img_date {
    position: relative;
    bottom: 80px;
    min-width: 30px;
}

.img_date_with_no_img {
    bottom: 40px !important;
}

.with_img_border {
    border: 2px solid #709F34;
    height: 100%;
    width: 100%;
}

.no_img_border {
    border: 2px solid #B2B2B2;
    height: 100%;
    width: 100%;
}

.file_upload_error_border {
    border: 2px solid #DA4E4E;
    height: 100%;
    width: 100%;
}

.upld-err-msg {
    color: #DA4E4E;
    margin: 5px 0px;
}

</style>
